import { render, staticRenderFns } from "./DialogInfoTotalBruto.vue?vue&type=template&id=a979e9b8&lang=pug"
import script from "./DialogInfoTotalBruto.vue?vue&type=script&lang=js"
export * from "./DialogInfoTotalBruto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports